import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import DigitalMarketingPune from "../components/blogs/DigitalMarketingPune";

const DigitalMarketingAgencyPune = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.search) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <title>Digital Marketing Agency in Pune | SMS ZOO ZOO</title>
        <meta
          name="description"
          content="SMS ZOO ZOO is a trusted digital marketing agency in Pune offering SEO, Google Ads, social media marketing, and lead generation solutions."
        />

        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://www.smszoozoo.com/digital-marketing-agency-pune"
        />
      </Helmet>

      <Navbar />
      <DigitalMarketingPune />
      <Footer />
    </>
  );
};

export default DigitalMarketingAgencyPune;
